export default __webpack_public_path__ + "static/media/stump.d2c121a3.png";